import React from "react";
import { useCons } from "../context/ConsContext";
import "./index.css";

const Send = () => {
  const { modelos } = useCons();

  return (
    <div className="fullH send">
      <div className="container-lg">
        <div className="colorBox flex flexRow">
          <div className="textCol flex flexCol justifyCenter">
            <h1 className="relative">
              ¡Gracias!
              <br />
              <span className="stroke">Recibimos tus datos</span>
            </h1>
            <h3 className="relative">
              Un representante de Volkswagen se pondrá en contacto con vos en
              breve.
            </h3>
          </div>
          <div className="modelo">
            <img src={modelos[0].img} alt="Modelo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Send;
